import { render, staticRenderFns } from "./arrive_notice.vue?vue&type=template&id=6943c995&scoped=true&functional=true"
var script = {}
import style0 from "./arrive_notice.vue?vue&type=style&index=0&id=6943c995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6943c995",
  null
  
)

export default component.exports